import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tag } from '@/js/libs/ui/src/V2';

import type { ColumnProps } from '../../types';

export const OutcomeCell: React.FC<ColumnProps> = React.memo(function OutcomeCell({ item }) {
  const [t] = useTranslation(['backend', 'serviceDashboard']);
  const outcome = item.outcome ? t(item.outcome, { ns: 'serviceDashboard' }) : '';

  if (!item.outcome) {
    return null;
  }

  return <Tag title={outcome} />;
});
